import BaseApi from './base'

class RolesConfiguration extends BaseApi {
  getRolesConfiguration = () => this.client.get(`admin/roles-configuration`)

  updateRolesConfiguration = (data) =>
    this.client.post(`admin/roles-configuration`, data)

  getAllowedRoleManage = (query) =>
    this.client.get(`admin/roles-configuration/allow-manage?${query}`)

  updateAllowedRoleManage = (data) =>
    this.client.patch(`admin/roles-configuration/allow-manage`, data)
}

export default new RolesConfiguration()
